import { render } from "./InstagramIcon.vue?vue&type=template&id=b170ccf0"
const script = {}
script.render = render

export default script